import { useState } from "react";
import { api, formatErr } from "../lib/api";
import { toast } from "sonner";
import { X, Flag } from "@phosphor-icons/react";

export default function ReportModal({ open, onClose, targetType, targetId }) {
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);

    if (!open) return null;

    const submit = async (e) => {
        e.preventDefault();
        if (!reason.trim()) return toast.error("Please provide a reason");
        setLoading(true);
        try {
            await api.post("/reports", { target_id: targetId, target_type: targetType, reason });
            toast.success("Report submitted. Mods will review it shortly.");
            setReason("");
            onClose();
        } catch (e) { toast.error(formatErr(e)); }
        setLoading(false);
    };

    return (
        <div className="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
            <div className="bg-[#131a2a] border border-rose-500/40 rounded-sm max-w-md w-full p-6" onClick={(e) => e.stopPropagation()} data-testid="report-modal">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <Flag size={18} weight="duotone" className="text-rose-400" />
                        <h3 className="font-bold text-base tracking-tight" style={{ fontFamily: "'Space Grotesk', 'Chivo', sans-serif" }}>Report content</h3>
                    </div>
                    <button onClick={onClose} className="text-slate-500 hover:text-slate-200"><X size={18} /></button>
                </div>
                <p className="text-xs text-slate-400 font-mono mb-3">// what's wrong with this? mods will review.</p>
                <form onSubmit={submit} className="space-y-3">
                    <textarea
                        required
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="spam, harassment, illegal content, off-topic..."
                        className="w-full h-24 bg-[#0b0f19] border border-white/10 text-slate-200 text-sm font-mono p-3 rounded-sm focus:border-rose-500 focus:ring-1 focus:ring-rose-500/30 focus:outline-none resize-none"
                        data-testid="report-reason"
                        maxLength={500}
                    />
                    <div className="flex gap-2">
                        <button type="submit" disabled={loading} className="bg-rose-500 hover:bg-rose-400 text-slate-950 font-bold text-xs uppercase tracking-widest px-4 py-2 rounded-sm disabled:opacity-50" data-testid="report-submit">
                            {loading ? "…" : "Submit report"}
                        </button>
                        <button type="button" onClick={onClose} className="border border-white/10 hover:border-slate-700 text-slate-400 text-xs uppercase tracking-widest px-4 py-2 rounded-sm">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
